function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEventList = function SvgEventList(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8190_11922)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8190_11922",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 0H0V44H44V0Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8190_11922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 43.8896C34.155 43.8896 44 34.0447 44 21.8896C44 9.73465 34.155 -0.110352 22 -0.110352C9.845 -0.110352 0 9.73465 0 21.8896C0 34.0447 9.845 43.8896 22 43.8896Z",
    fill: "#EBEBEB",
    style: _defineProperty(_defineProperty({
      fill: "#EBEBEB"
    }, "fill", "color(display-p3 0.9216 0.9216 0.9216)"), "fillOpacity", 1)
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8190_11922",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 0H0V44H44V0Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8190_11922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9549 32.7804C31.9549 33.4404 31.4599 33.9354 30.7999 33.9354H13.1999C12.5399 33.9354 12.0449 33.4404 12.0449 32.7804V11.2204C12.0449 10.5604 12.5399 10.0654 13.1999 10.0654H30.7999C31.4599 10.0654 31.9549 10.5604 31.9549 11.2204V32.7804Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6748 23.5405C15.6748 23.2105 15.9498 22.9355 16.2798 22.9355H27.6648C27.9948 22.9355 28.2698 23.2105 28.2698 23.5405V23.9255C28.2698 24.2555 27.9948 24.5305 27.6648 24.5305H16.2798C15.9498 24.5305 15.6748 24.2555 15.6748 23.9255V23.5405Z",
    fill: "#EA4403",
    style: _defineProperty(_defineProperty({
      fill: "#EA4403"
    }, "fill", "color(display-p3 0.9176 0.2667 0.0118)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6748 15.1255C15.6748 14.7955 15.9498 14.5205 16.2798 14.5205H27.6648C27.9948 14.5205 28.2698 14.7955 28.2698 15.1255V15.5105C28.2698 15.8405 27.9948 16.1155 27.6648 16.1155H16.2798C15.9498 16.1155 15.6748 15.8405 15.6748 15.5105V15.1255Z",
    fill: "#260046",
    style: _defineProperty(_defineProperty({
      fill: "#260046"
    }, "fill", "color(display-p3 0.1490 0.0000 0.2745)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6748 19.3052C15.6748 18.9752 15.9498 18.7002 16.2798 18.7002H27.6648C27.9948 18.7002 28.2698 18.9752 28.2698 19.3052V19.6902C28.2698 20.0202 27.9948 20.2952 27.6648 20.2952H16.2798C15.9498 20.2952 15.6748 20.0202 15.6748 19.6902V19.3052Z",
    fill: "#EA4403",
    style: _defineProperty(_defineProperty({
      fill: "#EA4403"
    }, "fill", "color(display-p3 0.9176 0.2667 0.0118)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6748 27.7759C15.6748 27.4459 15.9498 27.1709 16.2798 27.1709H25.1348C25.4648 27.1709 25.7398 27.4459 25.7398 27.7759V28.1609C25.7398 28.4909 25.4648 28.7659 25.1348 28.7659H16.2798C15.9498 28.7659 15.6748 28.4909 15.6748 28.1609V27.7759Z",
    fill: "#EA4403",
    style: _defineProperty(_defineProperty({
      fill: "#EA4403"
    }, "fill", "color(display-p3 0.9176 0.2667 0.0118)"), "fillOpacity", 1)
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8190_11922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEventList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/event-list.35cf9328564a2e47002eab824e690b32.svg";